import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = ({ placeholder, className, ...field }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="relative">
            <input
                {...field}
                type={visible ? "text" : "password"}
                placeholder={placeholder}
                className={`w-full rounded-xl border border-slate-200 bg-input-bg px-4 py-3 pr-11 text-sm outline-none focus:outline-none transition focus:border-primary ${className || ""}`}
            />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"
                tabIndex={-1}
            >
                {visible ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
            </button>
        </div>
    );
};

export default PasswordInput;
